import { FormDialogConfig, Icon } from '@aibees/shared/components';
import { yup } from '@aibees/shared/utils';
import { PASSWORD_RULE } from '@aibees/shared/utils/yup';

export const icon = <Icon name="edit" />;

const config: FormDialogConfig = {
  title: 'Change Password?',
  scheme: yup.object().shape({
    currentPassword: yup
      .string()
      .required('Current Password  is required')
      .max(50, 'Maximum 50 characters allowed'),
    password: yup
      .string()
      .required('New Password  is required')
      .matches(...PASSWORD_RULE)
      .max(50, 'Maximum 50 characters allowed'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password')], 'Passwords must match')
      .max(50, 'Maximum 50 characters allowed'),
  }),
};

export default config;
